import * as React from 'react';

import FolderExternal16 from './FolderExternal16';

export const folderExternal16 = () => <FolderExternal16 />;

export default {
    title: 'Icon|Fill|FolderExternal16',
    component: FolderExternal16,
    parameters: {
        notes: "`import FolderExternal16 from 'box-ui-elements/es/icon/fill/FolderExternal16';`",
    },
};
